import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import _cloneDeep from "lodash/cloneDeep";
import _groupBy from "lodash/groupBy";
import _map from "lodash/map";
import _assign from "lodash/assign";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import formatDate from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import ratesConfig, { ratesChartConfig } from '../config/rates-config';
import { INIT_TODAYS_RATE, RECEIVE_RATES } from './actions';

var getFormattedDate = function getFormattedDate(dateString) {
  return formatDate(parseISO(dateString), 'MMMM d, yyyy');
};

function getNormalizedData(data) {
  var rates = _get(data, 'rates', []);

  var aprs = _get(data, 'aprs', {});

  var interestRates = _get(data, 'interestRates', {});

  return {
    rateSummary: {
      today: _get(data, 'today'),
      yearly: _get(data, 'yearly'),
      yesterday: _get(data, 'yesterday'),
      weekly: _get(data, 'weekly'),
      rates: ratesConfig.reduce(function (result, config) {
        return _assign(result, _defineProperty({}, config.homeownershipKey, {
          apr: _get(aprs, "".concat(config.homeownershipKey)),
          interestRate: _get(interestRates, "".concat(config.homeownershipKey))
        }));
      }, {})
    },
    chartData: {
      data: ratesChartConfig.map(function (config) {
        return [config.label].concat(rates.map(function (rate) {
          return _get(rate, config.homeownershipKey);
        }));
      }),
      days: rates.map(function (rate) {
        return getFormattedDate(rate.date);
      }),
      labels: _map(_groupBy(rates, function (rate) {
        return formatDate(parseISO(rate.date), 'yyyyMM');
      }), function (group) {
        return getFormattedDate(group[Math.floor((group.length - 1) / 2)].date);
      })
    }
  };
}

function getInitialState() {
  return {
    chartData: {},
    localRates: {},
    rateSummary: {}
  };
}

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var newState = state;

  switch (action.type) {
    case INIT_TODAYS_RATE:
      {
        newState = _cloneDeep(state);
        newState.todaysRateConfig = ratesConfig.find(function (c) {
          return c.homeownershipKey === action.rateKey;
        });
        return newState;
      }

    case RECEIVE_RATES:
      newState = _cloneDeep(state);
      newState = _objectSpread(_objectSpread({}, newState), getNormalizedData(action.data));
      break;

    default:
      break;
  } // Return the new state.


  return newState;
});